import { render } from "./Mb002.vue?vue&type=template&id=945b5f66&scoped=true"
import script from "./Mb002.vue?vue&type=script&lang=js"
export * from "./Mb002.vue?vue&type=script&lang=js"

import "./Mb002.vue?vue&type=style&index=0&id=945b5f66&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-945b5f66"]])

export default __exports__